import { Box } from "@mui/system";
import { colors } from "../../theme/designTokens";

export default function LoadingBox({ w, h }) {
  return (
    <Box
      sx={{
        width: w ? w : "200px",
        height: h ? h : 80,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 44,
          height: 44,
          "@keyframes esm-spin": {
            "0%": { transform: "rotate(0deg)" },
            "100%": { transform: "rotate(360deg)" },
          },
          "@keyframes esm-pulse": {
            "0%, 100%": { transform: "translate(-50%, -50%) scale(0.6)", opacity: 0.5 },
            "50%": { transform: "translate(-50%, -50%) scale(1)", opacity: 1 },
          },
        }}
      >
        {/* track */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            border: `3px solid ${colors.primaryLight}`,
          }}
        />
        {/* spinning arc */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            borderRadius: "50%",
            border: "3px solid transparent",
            borderTopColor: colors.primary,
            borderRightColor: colors.accent,
            animation: "esm-spin 0.85s linear infinite",
          }}
        />
        {/* pulsing center dot */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: colors.accent,
            transform: "translate(-50%, -50%)",
            animation: "esm-pulse 0.85s ease-in-out infinite",
          }}
        />
      </Box>
    </Box>
  );
}
